export default __webpack_public_path__ + "static/media/SyllabusIcon.a4261efb.svg";